import { accessRole } from "../../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"

import IndexBloc from "./Blocs/IndexBloc"

import Select from "react-select"

import TableActiveComponent from './Components/TableActiveComponent'

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();
    const currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    const [activeTab, setactiveTab] = useState("1")
    const activeRef = useRef();
    const inactiveRef = useRef();

    // Select
    const [optionUnits, setOptionUnits] = useState([]);
    const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([]);
    const [optionEchelon, setOptionEchelon] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedStatus, setSelectedStatus] = useState({
      label: 'INTERNAL',
      value: 'f3dd847a-ed83-4539-9a16-7df9048cd42b'
    })
    const [selectedEchelon, setSelectedEchelon] = useState("")

    const handleSelectUnit = (selectedUnit) => {
      setSelectedUnit(selectedUnit)
    }
    const handleSelectStatus = (selectedStatus) => {
        setSelectedStatus(selectedStatus)
    }
    const handleSelectEchelon = (sel) => {
        setSelectedEchelon(sel)
    }

    useEffect( () => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(
                          reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid')
                        )
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        indexBloc.employeeCategoriesChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      setOptionEmployeeStatus(
                        reformatOptions(response, 'employee_categories_name_full', 'employee_categories_uuid')
                      )
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        })

        indexBloc.echelonChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      setOptionEchelon(
                        reformatOptions(response, 'echelon_name', 'echelon_name')
                      )
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        })
  
      indexBloc.fetchWorkUnit({})
      indexBloc.fetchEmployeeCategories({})
      indexBloc.fetchEchelon({})

      return () => {
          console.log('unmount');
          indexBloc.workUnitChannel?.unsubscribe()
          indexBloc.employeeCategoriesChannel?.unsubscribe()
          indexBloc.echelonChannel?.unsubscribe()
      }
    }, [])

    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')

    let additionalFilter = {
        nip: nip,
        name: name,
        work_unit: selectedUnit.value || "",
        emp_categories: selectedStatus.value || "",
        echelon: selectedEchelon.value || ""
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
      setNip('');
      setName('');
      setSelectedUnit('')
      setSelectedStatus('')
      setSelectedEchelon('')

      setTimeout(function() {
        reloadActiveRef()
      }, 100);
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                {/* <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">Tambah Pegawai</Button>
                                        </Link>
                                    : null
                                }
                                </div> */}
                                <div className="float-end">
                                    <Link to={`/izinpegawai/dinas.html`}>
                                        <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                    </Link>
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />

                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="nip"
                                            value={nip}
                                            onChange={event => setNip(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Nama
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="name"
                                            value={name}
                                            onChange={event => setName(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row> */}
                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Status Pegawai
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEmployeeStatuss.filter(option => 
                                              option.value === selectedStatus.value)}
                                            onChange={handleSelectStatus}
                                            required="required"
                                            options={optionEmployeeStatuss}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option => 
                                              option.value === selectedUnit.value)}
                                            onChange={handleSelectUnit}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Eselon
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEchelon.filter(option => 
                                              option.value === selectedEchelon.value)}
                                            onChange={handleSelectEchelon}
                                            required="required"
                                            options={optionEchelon}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row>
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView